const none = "none";
const triggerPress = "trigger-press";
const triggerHover = "trigger-hover";
const triggerFocus = "trigger-focus";
const outsidePress = "outside-press";
const itemPress = "item-press";
const closePress = "close-press";
const focusOut = "focus-out";
const escapeKey = "escape-key";
const listNavigation = "list-navigation";
const cancelOpen = "cancel-open";
const siblingOpen = "sibling-open";
const disabled = "disabled";
const missing = "missing";
const initial = "initial";
const imperativeAction = "imperative-action";
export {
  cancelOpen,
  closePress,
  disabled,
  escapeKey,
  focusOut,
  imperativeAction,
  initial,
  itemPress,
  listNavigation,
  missing,
  none,
  outsidePress,
  siblingOpen,
  triggerFocus,
  triggerHover,
  triggerPress
};
//# sourceMappingURL=reason-parts.js.map
